import { ReactComponent as DropdownMenuIcon } from "assets/icons/dropdown-menu.svg"
import { ReactComponent as UnreadIcon } from "assets/icons/unread.svg"
import { ReactComponent as ReplyIcon } from "assets/icons/reply.svg"

import { IMessage } from "./queries"

import { useAuth } from "providers/auth"
import styles from "./styles.module.scss"
import { useTranslation } from "react-i18next"
import { Dropdown, MenuProps } from "antd"

interface IProps {
  message: IMessage
  setHoveredMessage: () => void
  onReply: (msg: IMessage) => void
  actionsModal: {
    open: () => void
    onClose: () => void
    isOpen: boolean
  }
  onMarkUnread: (id: string) => void
}

const MessageActions: React.FC<IProps> = ({
  onReply,
  message,
  actionsModal,
  setHoveredMessage,
  onMarkUnread,
}) => {
  const { t } = useTranslation("suite/home")
  const profile = useAuth()
  //const id = useMemberId()

  const isMessageCreator = message.creator.email === profile.user?.email

  const actions: MenuProps["items"] = [
    {
      key: "2",
      label: (
        <div className={styles.action}>
          <ReplyIcon />
          {t("discussion.reply")}
        </div>
      ),
      onClick: () => {
        onReply(message)
        setHoveredMessage()
        actionsModal.onClose()
      },
    },
    {
      key: "3",
      label: (
        <div className={styles.action}>
          <UnreadIcon />
          {t("discussion.mark_unread")}
        </div>
      ),
      disabled: isMessageCreator,
      onClick: () => {
        setHoveredMessage()
        actionsModal.onClose()
        onMarkUnread(message.id)
      },
    },
  ]

  return (
    <div className={styles.actionsContainer}>
      <div className={styles.actionsWrapper}>
        <Dropdown menu={{ items: actions }} placement="bottomRight">
          <div className={styles.actionsIconWrapper}>
            <DropdownMenuIcon />
          </div>
        </Dropdown>
      </div>
    </div>
  )
}

export default MessageActions
